import { apiFetch } from "./client";

/**
 * Submits guest order details to the backend.
 * Endpoint: POST /api/user/guest/checkout
 * Model: GuestCheckoutDto
 */
export function guestCheckout(body) {
  return apiFetch("/api/user/guest/checkout", {
    method: "POST",
    body: JSON.stringify(body),
    token: null, // explicit null so it never attaches authorization header
  });
}

/**
 * Fetches the calculated checkout summary (real-time shipping fees, subtotal, and total)
 * for a guest order based on selected district and cart items.
 * Primary Endpoint: POST /api/user/guest/checkout-summary
 * Fallback Endpoint: POST /api/user/guest/checkout/summary
 * Model: GuestCheckoutInfoDto -> CheckoutCartDto
 */
export async function getGuestCheckoutSummary(body) {
  try {
    return await apiFetch("/api/user/guest/checkout-summary", {
      method: "POST",
      body: JSON.stringify(body),
      token: null,
    });
  } catch (err) {
    if (err.status === 404 || err.status === 405) {
      return await apiFetch("/api/user/guest/checkout/summary", {
        method: "POST",
        body: JSON.stringify(body),
        token: null,
      });
    }
    throw err;
  }
}

/**
 * Requests an account setup / password creation link to be sent to the guest's email.
 * Endpoint: POST /api/user/guest/request-password-setup
 */
export function requestGuestPasswordSetup(email) {
  return apiFetch("/api/user/guest/request-password-setup", {
    method: "POST",
    body: JSON.stringify({ email }),
    token: null,
  });
}
